<!-- 時間帯マスタ　更新完了画面 -->
<style>
</style>
<template>
<div class="contents" id="wtmzn">
    <section id="mainContent">
    <h2>時間帯マスタ(更新完了画面)</h2>
      <section class="message">
        <h3>更新完了</h3>
        <p>時間帯マスタを更新しました。</p>
      </section>
      <div class="btnLst"><button class="backBtn" v-on:click="onReturn">戻る</button></div>
    </section>
  </div>
</template>

<script>
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'
  
  export default {
    name: 'MasterWTMZNDetailUpdate',        
    data() {
      return {}
    },
    methods: {      
      //一覧表示画面に戻る
      onReturn: function () {
        UtilityConsoleLog.consoleLog("MasterWTMZNDetail::onReturn Start")

        this.$router.push("/MasterWTMZNList")

        UtilityConsoleLog.consoleLog("MasterWTMZNDetail::onReturn End")
      },      
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WTMZN/MasterWTMZNDetailUpdate.vue